<template>
  <div class="pa-payment-methods">
    <p class="section-sub-label tw-mb-3">Payment method</p>
    <div class="pay-method-tabs tw-mb-4">
      <button
        type="button"
        :class="['pay-method-tab', activePayTab === 'mpesa' ? 'pay-tab-active' : '']"
        @click="$emit('update:activePayTab', 'mpesa')"
      >
        <img src="/mpesa.jpeg" alt="M-Pesa" class="pay-tab-mpesa-logo" />
        <span>M-Pesa STK</span>
      </button>
      <button
        type="button"
        :class="['pay-method-tab', activePayTab === 'paybill' ? 'pay-tab-active' : '']"
        @click="$emit('update:activePayTab', 'paybill')"
      >
        <img src="/mpesa.jpeg" alt="M-Pesa" class="pay-tab-mpesa-logo" />
        <span>Paybill</span>
      </button>
    </div>

    <div v-if="activePayTab === 'mpesa'" class="pay-panel">
      <div class="mpesa-panel-card tw-mb-4">
        <div class="mpesa-panel-header">
          <img src="/mpesa.jpeg" alt="M-Pesa" class="mpesa-panel-logo" />
          <div>
            <p class="mpesa-panel-title">Lipa Na M-Pesa</p>
            <p class="mpesa-panel-sub">STK Push — you will receive a prompt on your phone</p>
          </div>
        </div>
        <label class="input-label tw-mt-4">M-Pesa phone number <span class="req">*</span></label>
        <v-text-field
          :value="mpesaPhone"
          placeholder="e.g. 0712345678"
          type="tel"
          outlined
          dense
          hide-details="auto"
          maxlength="10"
          class="custom-input"
          :disabled="paying"
          @input="$emit('update:mpesaPhone', $event)"
        />
        <p class="pay-ref-chip tw-mt-3">
          <span class="pay-ref-label">Account ref.</span>
          <span class="pay-ref-code">{{ paymentReference || '—' }}</span>
        </p>
      </div>
      <button
        type="button"
        class="btn-pay tw-w-full"
        :disabled="!canPayMpesa"
        @click="$emit('pay-mpesa')"
      >
        <v-progress-circular
          v-if="paying"
          indeterminate
          size="16"
          width="2"
          color="white"
          class="tw-mr-2"
        />
        <template v-else>
          <v-icon small color="white" class="tw-mr-2">mdi-cellphone-wireless</v-icon>
        </template>
        {{ paying ? 'Waiting for M-Pesa…' : `Send STK Push · ${formattedPremium}` }}
      </button>
      <p class="pay-stk-hint">
        <v-icon x-small color="#94a3b8" class="pay-stk-hint-icon">mdi-information-outline</v-icon>
        <span class="pay-stk-hint-text">
          A payment prompt will appear on
          <strong class="pay-stk-phone">{{ mpesaPhone || 'your phone' }}</strong>.
          Enter your M-Pesa PIN to confirm.
        </span>
      </p>
    </div>

    <div v-if="activePayTab === 'paybill'" class="pay-panel">
      <div v-if="paybillFallback" class="paybill-fallback-alert tw-mb-4">
        <v-icon size="16" color="#D97706" class="tw-mr-2 tw-flex-shrink-0">mdi-alert-circle-outline</v-icon>
        <span>STK Push failed or timed out. Complete payment via Paybill below.</span>
      </div>
      <div class="paybill-panel-card tw-mb-4">
        <div class="paybill-panel-header">
          <img src="/mpesa.jpeg" alt="M-Pesa" class="mpesa-panel-logo" />
          <div>
            <p class="paybill-panel-title">M-Pesa Paybill</p>
            <p class="paybill-panel-sub">Lipa Na M-Pesa → Pay Bill</p>
          </div>
        </div>
        <div class="paybill-ussd-steps">
          <p class="paybill-ussd-title">
            <v-icon x-small color="#64748b" class="tw-mr-1">mdi-cellphone-text</v-icon>
            Quick steps
          </p>
          <div class="paybill-ussd-list">
            <div v-for="(step, i) in ussdSteps" :key="i" class="paybill-ussd-item">
              <span class="paybill-ussd-num">{{ i + 1 }}</span>
              <span v-html="step" />
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn-amber btn-amber--block"
        :disabled="!canPayPaybill"
        @click="$emit('verify-paybill')"
      >
        <v-progress-circular
          v-if="paying"
          indeterminate
          size="16"
          width="2"
          color="#1E4276"
          class="tw-mr-2"
        />
        <template v-else>
          <v-icon small color="#1E4276" class="tw-mr-2">mdi-check-circle-outline</v-icon>
        </template>
        {{ paying ? 'Validating payment…' : 'Validate payment' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaPaymentMethods',
  props: {
    paying: { type: Boolean, default: false },
    declarationsAccepted: { type: Boolean, default: false },
    nationalIdReady: { type: Boolean, default: false },
    kraReady: { type: Boolean, default: false },
    paymentReference: { type: String, default: '' },
    formattedPremium: { type: String, default: '' },
    mpesaPhone: { type: String, default: '' },
    activePayTab: { type: String, default: 'mpesa' },
    paybillFallback: { type: Boolean, default: false },
    ussdSteps: { type: Array, default: () => [] },
  },
  computed: {
    canPayMpesa() {
      return !this.paying
        && this.declarationsAccepted
        && this.nationalIdReady
        && this.kraReady
        && !!this.mpesaPhone
        && !!this.paymentReference;
    },
    canPayPaybill() {
      return !this.paying
        && this.declarationsAccepted
        && this.nationalIdReady
        && this.kraReady
        && !!this.paymentReference;
    },
  },
};
</script>

<style scoped>
.section-sub-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: #1E4276;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 0 0 10px;
}
.pay-method-tabs { display: flex; gap: 8px; }
.pay-method-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1.5px solid #E8EDF2;
  border-radius: 10px;
  background: white;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 600;
  color: #64748b;
  transition: all 0.15s;
}
.pay-method-tab:hover { border-color: #BAE6FD; color: #1E4276; }
.pay-tab-active {
  border-color: #1E4276 !important;
  background: #F0F4FA !important;
  color: #1E4276 !important;
  box-shadow: 0 0 0 1px #1E4276;
}
.pay-tab-mpesa-logo { height: 22px; object-fit: contain; }
.pay-panel { animation: payFadeIn 0.2s ease-out; }
@keyframes payFadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}
.mpesa-panel-card {
  background: #F8FBFF;
  border: 1.5px solid #DEE9F5;
  border-radius: 12px;
  padding: 16px;
}
.mpesa-panel-header { display: flex; align-items: center; gap: 12px; }
.mpesa-panel-logo { height: 36px; object-fit: contain; }
.mpesa-panel-title { font-size: 0.88rem; font-weight: 700; color: #1E4276; margin: 0 0 2px; }
.mpesa-panel-sub { font-size: 0.72rem; color: #64748b; margin: 0; }
.input-label { font-size: 0.78rem; font-weight: 600; color: #334155; display: block; }
.req { color: #DC2626; }
.pay-ref-chip {
  display: inline-flex;
  align-items: center;
  background: white;
  border: 1px solid #E8EDF2;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.72rem;
}
.pay-ref-label { color: #94a3b8; margin-right: 5px; font-weight: 600; }
.pay-ref-code {
  font-family: ui-monospace, monospace;
  font-weight: 700;
  color: #1E4276;
  letter-spacing: 0.05em;
}
.pay-stk-hint {
  margin-top: 14px;
  padding: 12px 14px;
  font-size: 0.8rem;
  color: #64748b;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  line-height: 1.55;
  background: #F8FAFC;
  border: 1px solid #E8EDF2;
  border-radius: 10px;
}
.pay-stk-hint-icon { flex-shrink: 0; margin-top: 2px; }
.pay-stk-hint-text { flex: 1; min-width: 0; }
.pay-stk-phone { white-space: nowrap; color: #1E4276; font-weight: 700; }
.btn-pay {
  margin-top: 4px;
  height: 48px;
  background: linear-gradient(135deg, #1E4276, #2A5A9E);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(30, 66, 118, 0.3);
  transition: all 0.2s;
}
.btn-pay:hover:not(:disabled) { transform: translateY(-1px); }
.btn-pay:disabled { opacity: 0.5; cursor: not-allowed; }
.btn-amber {
  height: 48px;
  background: #FFC107;
  color: #1E4276;
  border: none;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(255, 193, 7, 0.35);
}
.btn-amber--block { width: 100%; }
.btn-amber:disabled { opacity: 0.5; cursor: not-allowed; }
.paybill-fallback-alert {
  display: flex;
  align-items: flex-start;
  padding: 10px 12px;
  background: #FFFBEB;
  border: 1px solid #FDE68A;
  border-radius: 10px;
  font-size: 0.78rem;
  color: #92400E;
}
.paybill-panel-card {
  background: white;
  border: 1.5px solid #E8EDF2;
  border-radius: 12px;
  overflow: hidden;
}
.paybill-panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: linear-gradient(90deg, #1E4276 0%, #2A5A9E 100%);
}
.paybill-panel-title { font-size: 0.88rem; font-weight: 700; color: white; margin: 0 0 2px; }
.paybill-panel-sub { font-size: 0.72rem; color: rgba(255, 255, 255, 0.75); margin: 0; }
.paybill-ussd-steps { background: #F8FBFF; padding: 12px 16px; }
.paybill-ussd-title {
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 0 0 8px;
  display: flex;
  align-items: center;
}
.paybill-ussd-list { display: flex; flex-direction: column; gap: 5px; }
.paybill-ussd-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.78rem;
  color: #334155;
  line-height: 1.45;
}
.paybill-ussd-num {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #1E4276;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}

@media (max-width: 600px) {
  .pay-method-tabs {
    flex-direction: column;
    gap: 8px;
  }
  .pay-method-tab {
    min-height: 48px;
    padding: 12px 14px;
  }
  .mpesa-panel-header,
  .paybill-panel-header {
    flex-wrap: wrap;
  }
  .mpesa-panel-card { padding: 14px; }
  .pay-stk-phone { white-space: normal; word-break: break-word; }
  .pay-stk-hint { font-size: 0.75rem; padding: 10px 12px; }
  .paybill-ussd-item { font-size: 0.74rem; }
  .btn-pay,
  .btn-amber {
    width: 100%;
    min-height: 48px;
  }
}
</style>
